const KEY = "mpl-tenant";

export const getTenant = () => localStorage.getItem(KEY) || null;

export function enterTenant(leagueId, to = "/tableau-de-bord", auto = false) {
  localStorage.setItem(KEY, leagueId);
  if (auto) localStorage.setItem(`${KEY}-auto`, "1"); else localStorage.removeItem(`${KEY}-auto`);
  window.location.assign(to);
}

export const tenantIsAuto = () => localStorage.getItem(`${KEY}-auto`) === "1";

export function leaveTenant() {
  localStorage.removeItem(KEY);
  localStorage.removeItem(`${KEY}-auto`);
  window.location.assign("/tableau-de-bord");
}

export const TENANT_BLOCKED = [/^\/offres/, /^\/ligues\/nouvelle/];
